export default __webpack_public_path__ + "static/media/add.c19e2dfe.svg";